export default "__VITE_ASSET__f7fce01d__"